import CardDocument from 'components/CardDocument';
import CardButton from 'components/CardButton';
import MainCard from 'components/MainCard';
import React, { useCallback, useEffect, useState } from 'react'
import Slider from 'react-slick';
import ArrowButton from 'components/ArrowButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getProfile } from 'services/apiRoutes';
import { useContext } from 'react';
import { userContext } from 'Context/userContext';
import SkeletonMaincard from 'skeletons/SkeletonMaincard';
import SkeletonCardDocument from 'skeletons/SkeletonCardDocument';

export default function DocumentPage() {
      const {slug}= useParams()
      const {values} = useContext(userContext);
      
      const [profile, setProfile] = useState();

      const [kegiatan,setKegiatan]= useState();


      const profileAPI = useCallback(async () => {
        const res = await getProfile(slug);
        if (res.error) {
          return res.message;
        } else {
          const { data } = res.data;
          values.setData(data);
          setProfile(data);
          setKegiatan(data.Kegiatan)
        }
      }, [values,slug]);
   

      useEffect(() => {
        profileAPI();
      }, [profileAPI]);


  const navigate = useNavigate();
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    nextArrow: <ArrowButton right />,
    prevArrow: <ArrowButton />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="px-5 space-y-16 mt-36 xl:px-99">
      <div className="items-center justify-between xl:flex ">
        <div className="flex items-center justify-between xl:w-2/3 wrapperButton">
          <h1 className="text-base font-bold md:text-3xl">Dokumen</h1>
          <div className="buttonWrapped">
            <CardButton
              label="Semua Dokumen"
              onClick={() => navigate("documents")}
            />
          </div>
        </div>
        <h1 className="hidden text-base font-bold md:text-3xl xl:block">
          Kegiatan Mendatang
        </h1>
      </div>
      <div className="space-y-5 xl:space-x-10 xl:flex innerWrapper xl:space-y-0 ">
        <div className="px-5 py-8 space-y-2 border xl:py-20 xl:px-16 xl:w-2/3 documentWrapper rounded-2xl">
          {profile
            ? profile.Dokumen.map(
                (item, index) =>
                  index <= 2 && (
                    <CardDocument
                      key={index}
                      title={item.nama}
                      date={item.create_date.substring(0, 10)}
                      // writer="SDGs Gampong"
                      writer={
                        item.list_kategori_dokumen_obj[0]
                          ? item.list_kategori_dokumen_obj[0].kategori_obj.nama
                          : ""
                      }
                      onClick={() => navigate(`/${slug}/documents/${item.uuid}`)}
                    />
                  )
              )
            : [1, 2, 3].map((item) => <SkeletonCardDocument key={item} />)}
        </div>
        <div className="flex flex-col justify-between xl:w-1/3 cardWrap">
          <h1 className="block text-base font-bold my-14 md:text-3xl xl:hidden">
            Kegiatan Mendatang
          </h1>

          <Slider {...settings} className="rounded-2xl shadow-costumeShadow">
            {kegiatan
              ? kegiatan.map((item, index) => (
                  <MainCard
                    key={index}
                    cardSlide
                    title={item?.nama}
                    label={
                      item?.list_kategori_kegiatan_obj[0]
                        ? item?.list_kategori_kegiatan_obj[0]?.kategori_obj
                            ?.nama
                        : ""
                    }
                    img={item?.url_gambar}
                    onClick={() => navigate(`/${slug}/postkegiatan/${item.uuid}`)}
                  />
                ))
              : [1, 2, 3].map((item) => <SkeletonMaincard />)}
          </Slider>
          <div className="flex justify-end w-full mt-14 buttonWrapped">
            <CardButton
              label="Semua kegiatan"
              onClick={() => navigate("kegiatan")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
